var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"w-100"},[_c('Datepicker',{attrs:{"wrapper-class":"datepicker","input-class":"form-control","calendar-class":"rounded calendar","format":"yyyy-MM-dd","calendar-button":"","calendar-button-icon":"fal fa-calendar","language":_vm.ko,"value":_vm.value},on:{"selected":_vm.handleDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }